<template>
  <div>
    <!-- Dashboard Toggle for Admins -->
    <div v-if="isAdmin" class="button-toggle-row mb-3">
      <el-button
        :type="selectedView === 'admin' ? 'primary' : 'default'"
        @click="selectedView = 'admin'"
        class="toggle-button"
      >
        Admin
      </el-button>
      <el-button
        :type="selectedView === 'personal' ? 'primary' : 'default'"
        @click="selectedView = 'personal'"
        class="toggle-button"
      >
        Personal
      </el-button>
    </div>

    <!-- Dashboard Component -->
    <component :is="dashboardComponent" />
  </div>
</template>

<script>
import { useLoginStore } from "@/stores/loginStore";
import HomeDashboard from "./HomeDashboard.vue";
import CaregiverDashboard from "./CaregiverDashboard.vue";

export default {
  name: "DashboardWrapper",
  components: {
    HomeDashboard,
    CaregiverDashboard,
  },
  data() {
    return {
      selectedView: "admin", // Default to admin view for admins
    };
  },
  computed: {
    isAdmin() {
      const loginStore = useLoginStore();
      return loginStore.isAdmin;
    },
    dashboardComponent() {
      const loginStore = useLoginStore();

      // If user is NOT an admin (caregiver, employment specialist, lead, etc.)
      // Always show caregiver dashboard
      if (!loginStore.isAdmin) {
        return "CaregiverDashboard";
      }

      // If user is an admin
      // Show caregiver dashboard when "Personal" is selected
      if (this.selectedView === "personal") {
        return "CaregiverDashboard";
      }

      // Otherwise show admin dashboard
      return "HomeDashboard";
    },
  },
};
</script>

<style scoped>
.button-toggle-row {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0;
  margin: 0;
}

.toggle-button {
  border-radius: 0;
  min-width: 120px;
  margin: 0;
}

.toggle-button:first-child {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

.toggle-button:last-child {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}

.toggle-button:not(:first-child) {
  border-left: none;
}

:deep(.toggle-button.el-button--default) {
  background-color: #606266;
  border-color: #606266;
  color: #fff;
}

:deep(.toggle-button.el-button--default:hover) {
  background-color: #737373;
  border-color: #737373;
  color: #fff;
}

:deep(.toggle-button.el-button--primary) {
  background-color: #409eff;
  border-color: #409eff;
  color: #fff;
}

/* Responsive */
@media (max-width: 768px) {
  .button-toggle-row {
    flex-wrap: wrap;
  }

  .toggle-button {
    min-width: 100px;
    font-size: 0.875rem;
  }
}
</style>
